module.exports = __webpack_public_path__ + "media/application/images/icons/chevron-089dfbb463d779532dc7606547c75e05.svg";